var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"row",attrs:{"id":"rowSpinner"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 text-center mt-3"},[_c('span',{staticClass:"spinner spinner-border spinner-card flex-shrink-0",attrs:{"role":"status"}},[_c('span',{staticClass:"visually-hidden"})])])
}]

export { render, staticRenderFns }